import { defineStore } from "pinia";
import { getRequest } from "~/apis/requests/useApiCall";
import { History } from "~/projects/help-desk/types/history";
import { TicketActionHistory } from "~/projects/help-desk/types/ticketActionHistory";

export const useHistoriesStore = defineStore("historiesStore", {
  state: () => ({
    showMessageHistoryModal: false,
    selectedHistoryForView: {},

    _ownerTicketHistories: [] as Array<History>,
    // Number of earlier tickets the customer has, fetched on its own so a
    // "previous tickets" control can be shown without loading every
    // conversation of every earlier ticket.
    _previousTicketCount: 0,
    _historiesLoading: false,

    // What has been done to the open ticket itself — picked, transferred,
    // resolved — as opposed to the customer's earlier tickets above.
    _ticketActionHistory: [] as Array<TicketActionHistory>,
    _actionHistoryLoading: false,
  }),
  actions: {
    setShowMessageHistoryModal(value) {
      this.showMessageHistoryModal = value;
    },
    setSelectedHistoryForView(value) {
      this.selectedHistoryForView = value;
    },

    async getTicketActionHistory(ticketId: number) {
      this._actionHistoryLoading = true;
      this._ticketActionHistory = [];

      const { response, error } = await getRequest<TicketActionHistory[]>(
        `desk/tickets/${ticketId}/history`,
      );

      if (!error) {
        this.$state._ticketActionHistory = response.data;
      }

      this._actionHistoryLoading = false;
    },

    async getResolvedTicketHistory(ownerId: number, ticketId: number) {
      this._historiesLoading = true;
      const { response, error } = await getRequest<History[]>(
        `desk/tickets/resolved/${ownerId}/${ticketId}`,
      );
      if (!error) {
        this.$state._ownerTicketHistories = response.data;
      }
      this._historiesLoading = false;
    },

    async getPreviousTicketCount(ownerId: number, ticketId: number) {
      const { response, error } = await getRequest<{ count: number }>(
        `desk/tickets/resolved/count/${ownerId}/${ticketId}`,
      );

      this.$state._previousTicketCount = error ? 0 : response.data.count ?? 0;

      return this.$state._previousTicketCount;
    },

    resetOwnerTicketHistories() {
      this.$state._ownerTicketHistories = [];
      this.$state._previousTicketCount = 0;
    },
  },
  getters: {
    ownerTicketHistories: (state) => state._ownerTicketHistories,
    previousTicketCount: (state) => state._previousTicketCount,
    historiesLoading: (state) => state._historiesLoading,
  },
});
